import { useEffect } from 'react'

import { AdsManagerForBank } from 'src/ads/AdsManagerForBank'
import { AdsGramController } from 'src/ads/ads-gram/AdsGram'
import { MonetagController } from 'src/ads/monetag/Monetag'
import { Onclicka } from 'src/ads/onclicka/Onclicka'
import { Richads } from 'src/ads/richads/Richads'

export const useInitAdsProviders = () => {
  useEffect(() => {
    const initAdsProviders = async () => {
      await AdsManagerForBank.Instance.init()
      AdsGramController.Instance.initAdsControllers()
      await MonetagController.Instance.loadSdk()
      await Onclicka.Instance.init()
      await Richads.Instance.init()
    }

    initAdsProviders()
  }, [])
}
